module.exports = __webpack_public_path__ + "img/product-manage-introduce-01.07fc1674.png";